/* eslint-disable no-unused-vars */
import { useMediaQuery } from '@material-ui/core';
import React, { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'react-jss';
import FilterSelect from '../../../components/filter-select';
import PeriodSlider from '../../../components/period-slider';
import TerritoriesAutocomplete from '../../../components/territories-autocomplete';
import FiltersContext from '../../../context/filtering';
import useStyles from '../styles';

/**
 * Provides the data and components of the projections filters.
 */
export default function ProjectionsFilters() {
  const theme = useTheme();
  const classes = useStyles({ theme });
  const isBreak = useMediaQuery('(max-width:999px)');
  const { options, values, setters } = useContext(FiltersContext);
  const { t } = useTranslation();

  /**
   *  Render the scales filter component using memo.
   */
  const scalesFilter = useMemo(
    () => (
      <FilterSelect
        filterName={t('scales_title')}
        options={options.scales}
        value={values.scale}
        setValue={setters.setScale}
        firstColor={theme.colorPrimary}
        secondColor={theme.colorSecondary}
      />
    ),
    [t, options.scales, values.scale]
  );

  /**
   *  Render the projectionsDataType filter component using memo.
   */
  const projectionsDataTypeFilter = useMemo(
    () => (
      <FilterSelect
        filterName={t('dataType_title')}
        options={options.projectionsDataTypes}
        value={values.projectionsDataType}
        setValue={setters.setProjectionsDataType}
        firstColor={theme.colorPrimary}
        secondColor={theme.colorSecondary}
      />
    ),
    [t, options.projectionsDataTypes, values.projectionsDataType]
  );

  /**
   *  Render the scenario filter component using memo.
   */
  const scenarioFilter = useMemo(
    () => (
      <FilterSelect
        filterName="Cenário"
        options={options.scenarios}
        value={String(values.scenario)}
        setValue={setters.setScenario}
        firstColor={theme.colorPrimary}
        secondColor={theme.colorSecondary}
      />
    ),
    [t, options.scenarios, values.scenario]
  );

  return useMemo(
    () => (
      <>
        <div className={classes.filterItem}>
          <TerritoriesAutocomplete
            filterName="Território"
            firstColor={theme.colorPrimary}
            secondColor={theme.colorSecondary}
          />
        </div>
        <div className={classes.filterItem}>{scalesFilter}</div>
        <div
          style={isBreak ? {} : { maxWidth: '250px', minWidth: '120px' }}
          className={classes.filterItem}
        >
          {scenarioFilter}
        </div>
        <div className={classes.filterItem}>{projectionsDataTypeFilter}</div>

        {options.projectionsDates && (
          <div
            style={isBreak ? { minWidth: 'none' } : { minWidth: '120px' }}
            className={classes.filterItem}
          >
            <PeriodSlider
              datesOptions={options.projectionsDates.dates}
              setDate={setters.setProjectionsDate}
              indexDefault={options.projectionsDates.indexDefault}
              firstColor={theme.colorPrimary}
              secondColor={theme.colorSecondary}
            />
          </div>
        )}
      </>
    ),
    [classes, scalesFilter, projectionsDataTypeFilter, scenarioFilter, isBreak]
  );
}
